import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  eventCategoryList: [],
  eventCategoryLoading: false,
  eventCategoryPaginationData: {},
  eventCategoryDetails: {},
  updateEventCategory: false,

  eventSubCategoryList: [],
  eventSubCategoryLoading: false,
  eventSubCategoryPaginationData: {},
  eventSubCategoryDetails: {},
  updateEventSubCategory: false,

  eventSubCategoryDetails: {},
  eventSubCategoryDetailsLoading: false,
  eventList: [],
  eventLoading: false,
  eventPaginationData: {},
  eventDetails: {},
  eventDetailsLoading: false,
  eventRegisterUserList: [],
  eventRegisterUserLoading: false,
  // -------- Update / Status --------
  updateEventLoading: false,
  activeInactiveEventLoading: false,
  updateEventSuccess: false,
  modalOpen: false,
  ApiError: null,
}

const eventCategorySlice = createSlice({
  name: 'eventCategory',
  initialState,
  reducers: {
    // List
    getEventCategoryListApiData: (state) => {
      state.eventCategoryLoading = true
    },
    getEventCategoryListApiSuccess: (state, { payload }) => {
      state.eventCategoryLoading = false
      state.eventCategoryList = payload.data
      state.eventCategoryPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getEventCategoryListApiFailed: (state, { payload }) => {
      state.eventCategoryLoading = false
      state.ApiError = payload
    },

    // Details
    getEventCategoryDetailsApiData: (state) => {
      state.eventCategoryLoading = true
    },
    getEventCategoryDetailsApiSuccess: (state, { payload }) => {
      state.eventCategoryLoading = false
      state.eventCategoryDetails = payload.data
    },
    getEventCategoryDetailsApiFailed: (state, { payload }) => {
      state.eventCategoryLoading = false
      state.ApiError = payload
    },

    // Add
    addEventCategoryApiData: (state) => {
      state.updateEventCategory = false
      state.modalOpen = false
    },
    addEventCategoryApiSuccess: (state, { payload }) => {
      state.updateEventCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    addEventCategoryApiFailed: (state, { payload }) => {
      state.ApiError = payload
    },

    // Update
    updateEventCategoryApiData: (state) => {
      state.updateEventCategory = false
    },
    updateEventCategoryApiSuccess: (state, { payload }) => {
      state.updateEventCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateEventCategoryApiFailed: (state, { payload }) => {
      state.ApiError = payload
      state.modalOpen = false
    },

    // Active / Inactive
    activeInactiveEventCategoryApiData: (state) => {
      state.eventCategoryLoading = true
      state.updateEventCategory = false
    },
    activeInactiveEventCategoryApiSuccess: (state, { payload }) => {
      state.eventCategoryLoading = false
      state.updateEventCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveEventCategoryApiFailed: (state, { payload }) => {
      state.eventCategoryLoading = false
      state.ApiError = payload
      state.modalOpen = false
    },

    // -------- Event Sub Category List --------
    getEventSubCategoryListApiData: (state) => {
      state.eventSubCategoryLoading = true
    },
    getEventSubCategoryListApiSuccess: (state, { payload }) => {
      state.eventSubCategoryLoading = false
      state.eventSubCategoryList = payload.data
      state.eventSubCategoryPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
      }
    },
    getEventSubCategoryListApiFailed: (state, { payload }) => {
      state.eventSubCategoryLoading = false
      state.ApiError = payload
      state.modalOpen = false
    },

    // -------- Add --------
    addEventSubCategoryApiData: (state) => {
      state.updateEventSubCategory = false
      state.modalOpen = false
    },
    addEventSubCategoryApiSuccess: (state, { payload }) => {
      state.modalOpen = true
      state.updateEventSubCategory = true
      state.ApiError = payload
    },
    addEventSubCategoryApiFailed: (state, { payload }) => {
      state.ApiError = payload
      state.updateEventSubCategory = false
      state.modalOpen = false
      alert(JSON.stringify(payload, null, 2))
    },

    // -------- Update --------
    updateEventSubCategoryApiData: (state) => {
      state.updateEventSubCategory = false
    },
    updateEventSubCategoryApiSuccess: (state, { payload }) => {
      state.modalOpen = true
      state.updateEventSubCategory = true
      state.ApiError = payload
    },
    updateEventSubCategoryApiFailed: (state, { payload }) => {
      state.ApiError = payload
      state.updateEventSubCategory = false
      alert(JSON.stringify(payload, null, 2))
      state.modalOpen = false
    },

    // -------- Active / Inactive --------
    activeInactiveEventSubCategoryApiData: (state) => {
      state.eventSubCategoryLoading = true
      state.updateEventSubCategory = false
    },
    activeInactiveEventSubCategoryApiSuccess: (state, { payload }) => {
      state.eventSubCategoryLoading = false
      state.updateEventSubCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    activeInactiveEventSubCategoryApiFailed: (state, { payload }) => {
      state.ApiError = payload
      state.eventSubCategoryLoading = false
      state.updateEventSubCategory = false
      alert(JSON.stringify(payload, null, 2))
      state.modalOpen = false
    },

    getEventSubCategoryDetailsApiData: (state) => {
      state.eventSubCategoryDetailsLoading = true
    },
    getEventSubCategoryDetailsApiSuccess: (state, { payload }) => {
      state.eventSubCategoryDetailsLoading = false
      state.eventSubCategoryDetails = payload.data
    },
    getEventSubCategoryDetailsApiFailed: (state, { payload }) => {
      state.eventSubCategoryDetailsLoading = false
      state.ApiError = payload
    },

    // -------- Event List --------
    getEventListApiData: (state) => {
      state.eventLoading = true
    },
    getEventListApiSuccess: (state, { payload }) => {
      state.eventLoading = false
      state.eventList = payload.data
      state.eventPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getEventListApiFailed: (state, { payload }) => {
      state.eventLoading = false
      state.ApiError = payload
    },

    // -------- Event Details --------
    getEventDetailsApiData: (state) => {
      state.eventDetailsLoading = true
    },
    getEventDetailsApiSuccess: (state, { payload }) => {
      state.eventDetailsLoading = false
      state.eventDetails = payload.data
    },
    getEventDetailsApiFailed: (state, { payload }) => {
      state.eventDetailsLoading = false
      state.ApiError = payload
    },

    // -------- Event Register User List --------
    getEventRegisterUserListApiData: (state) => {
      state.eventRegisterUserLoading = true
    },
    getEventRegisterUserListApiSuccess: (state, { payload }) => {
      state.eventRegisterUserLoading = false
      state.eventRegisterUserList = payload.data
    },
    getEventRegisterUserListApiFailed: (state, { payload }) => {
      state.eventRegisterUserLoading = false
      state.ApiError = payload
    },

    // ================= UPDATE EVENT (PUT) =================

    updateEventApiData: (state) => {
      state.updateEventLoading = true
      state.updateEventSuccess = false
    },
    updateEventApiSuccess: (state, { payload }) => {
      state.updateEventLoading = false
      state.updateEventSuccess = true
      state.modalOpen = true // ✅ SUCCESS → MODAL OPEN
      state.ApiError = payload
    },
    updateEventApiFailed: (state, { payload }) => {
      state.updateEventLoading = false
      state.ApiError = payload
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= ACTIVE / INACTIVE EVENT (PATCH) =================

    activeInactiveEventApiData: (state) => {
      state.activeInactiveEventLoading = true
      state.updateEventSuccess = false
    },
    activeInactiveEventApiSuccess: (state, { payload }) => {
      state.activeInactiveEventLoading = false
      state.updateEventSuccess = true
      state.modalOpen = true // ✅ SUCCESS → MODAL OPEN
      state.ApiError = payload
    },
    activeInactiveEventApiFailed: (state, { payload }) => {
      state.activeInactiveEventLoading = false
      state.ApiError = payload
      alert(JSON.stringify(payload, null, 2))
    },

    resetEventError: (state) => {
      state.ApiError = null
      state.modalOpen = false
    },
  },
})

export const {
  getEventCategoryListApiData,
  getEventCategoryListApiSuccess,
  getEventCategoryListApiFailed,

  getEventCategoryDetailsApiData,
  getEventCategoryDetailsApiSuccess,
  getEventCategoryDetailsApiFailed,

  addEventCategoryApiData,
  addEventCategoryApiSuccess,
  addEventCategoryApiFailed,

  updateEventCategoryApiData,
  updateEventCategoryApiSuccess,
  updateEventCategoryApiFailed,

  activeInactiveEventCategoryApiData,
  activeInactiveEventCategoryApiSuccess,
  activeInactiveEventCategoryApiFailed,

  // LIST
  getEventSubCategoryListApiData,
  getEventSubCategoryListApiSuccess,
  getEventSubCategoryListApiFailed,

  // DETAILS
  getEventSubCategoryDetailsApiData,
  getEventSubCategoryDetailsApiSuccess,
  getEventSubCategoryDetailsApiFailed,

  // ADD
  addEventSubCategoryApiData,
  addEventSubCategoryApiSuccess,
  addEventSubCategoryApiFailed,

  // UPDATE
  updateEventSubCategoryApiData,
  updateEventSubCategoryApiSuccess,
  updateEventSubCategoryApiFailed,

  // ACTIVE / INACTIVE
  activeInactiveEventSubCategoryApiData,
  activeInactiveEventSubCategoryApiSuccess,
  activeInactiveEventSubCategoryApiFailed,

  getEventListApiData,
  getEventListApiSuccess,
  getEventListApiFailed,
  getEventDetailsApiData,
  getEventDetailsApiSuccess,
  getEventDetailsApiFailed,

  getEventRegisterUserListApiData,
  getEventRegisterUserListApiSuccess,
  getEventRegisterUserListApiFailed,

  updateEventApiData,
  updateEventApiSuccess,
  updateEventApiFailed,

  activeInactiveEventApiData,
  activeInactiveEventApiSuccess,
  activeInactiveEventApiFailed,

  resetEventError,
} = eventCategorySlice.actions

export default eventCategorySlice.reducer
